import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../static/styles/EditProfile.module.css';
import MessagePopup from '../components/MessagePopup';
import { completeRedemption } from '../api/rewards';
import { isAuthenticated } from '../api/auth';

const RedeemForm = ({ reward }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [pubgId, setPubgId] = useState("");

    const [popupMessage, setPopupMessage] = useState("");
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        document.title = "Redeem Form | Jazz ESL";
        if(!isAuthenticated()) {
            window.location.href = process.env.REACT_APP_LOGIN_URL;
        }
        if(!location.state) {
            navigate('/rewards');
            return;
        }
        
        setName(location.state.reward.name)
    }, []);

    const handleRedemption = () => {
        const isIdRequired = location.state?.reward?.id_require;
        const isPubgIdValid = !isIdRequired || (pubgId && pubgId.length >= 9 && pubgId.length <= 13 && /^\d+$/.test(pubgId));
        const isFormValid = name && email && isPubgIdValid;
        
        if (isFormValid) {
            const data = {
                item: location.state.reward.item,
                uuid: location.state.reward.uuid,
                name: name,
                email: email,
                phone: location.state.reward.tel,
            };

            if (isIdRequired) {
                data.pubgId = pubgId;
            }

            completeRedemption(data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.success) {
                            navigate('/thankyou')
                        } else {
                            const errorMessage = response.data?.data?.message || "Redemption failed. Please try again.";
                            setPopupMessage(errorMessage);
                            setIsPopupOpen(true);
                        }
                    } else {
                        setPopupMessage("Redemption failed. Please try again.");
                        setIsPopupOpen(true);
                    }
                })
                .catch(error => {
                    setPopupMessage("An error occurred. Please try again.");
                    setIsPopupOpen(true);
                });
        } else {
            const isIdRequired = location.state?.reward?.id_require;
            if (isIdRequired && !pubgId) {
                setPopupMessage("Please fill in all fields including PUBG ID.");
            } else if (isIdRequired && pubgId && (pubgId.length < 9 || pubgId.length > 13 || !/^\d+$/.test(pubgId))) {
                setPopupMessage("PUBG ID must be 9-13 digits and contain only numbers.");
            } else {
                setPopupMessage("Please fill in all fields.");
            }
            setIsPopupOpen(true);
        }
    }

    return (
        <div className={styles.editProfile}>
            <h3 style={{textAlign: 'center', color: '#E3931B'}}>Congratulations!</h3>
            <p style={{textAlign:'center'}}>You can redeem your ESL Coins to purchase. 
            Please Enter Your Details Below</p>
            <div className={styles.formGroup}>
                <label>Name</label>
                <input value={name} onChange={e => setName(e.target.value)} placeholder="Enter Name" required />
            </div>

            <div className={styles.formGroup}>
                <label>Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Enter email address"
                    required
                />
            </div>

            {location.state?.reward?.id_require && (
                <div className={styles.formGroup}>
                    <label>PUBG ID</label>
                    <input
                        type="text"
                        value={pubgId}
                        onChange={e => setPubgId(e.target.value.replace(/[^0-9]/g, ''))}
                        placeholder="Enter PUBG ID"
                        minLength={9}
                        maxLength={13}
                        required
                    />
                </div>
            )}
            
            <div className={styles.formGroup}>
                <label>Mobile Numer</label>
                <input required value={location.state.reward.tel} />
            </div>
            
            <button
                className={styles.saveButton}
                onClick={handleRedemption}
            >
                Claim
            </button>

            <MessagePopup
                isOpen={isPopupOpen}
                message={popupMessage}
                onClose={() => {setIsPopupOpen(false);}}
            />
        </div>
    );
};

export default RedeemForm;